import { render, staticRenderFns } from "./JenisProyek.vue?vue&type=template&id=77dd8c7d&"
import script from "./JenisProyek.vue?vue&type=script&lang=js&"
export * from "./JenisProyek.vue?vue&type=script&lang=js&"
import style0 from "./JenisProyek.vue?vue&type=style&index=0&id=77dd8c7d&prod&lang=css&"
import style1 from "./JenisProyek.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports